export const OPTIONS = {
  dashboard: {
    basicOptions: [
      { key: 'crossVisualFiltersPublish', defaultValue: true },
      { key: 'crossVisualFiltersSubscribe', defaultValue: false },
    ],
    advancedOptions: [],
  },
  report: {
    basicOptions: [
      { key: 'crossVisualFiltersPublish', defaultValue: true },
      { key: 'crossVisualFiltersSubscribe', defaultValue: false },
    ],
    advancedOptions: [],
  },
};
